import { MutationTree } from "vuex";

import MutationType from "./mutation-type";
import State from "./state";

const mutations: MutationTree<State> = {};

export default mutations;
